export default __webpack_public_path__ + "static/air-quality-activity-guide-schools-SPA-1fe8673adc8d5fcd44e3b226fbc80694.pdf";